import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { isPad, isJ18 } from "./assets";
//通过js设置font-size
const mql = [
  window.matchMedia("(max-width:400px)"),
  window.matchMedia("(min-width:400px)")
];
(function mediaMatchs() {
  let html = document.getElementsByTagName("html")[0];
  if (isJ18) { //j18
    html.style.fontSize = "40px"; 
  } else if (mql[0].matches && !isPad && !isJ18) { //普通手机
    html.style.fontSize = "10vw";
  } else if (mql[1].matches || isPad) { //pad 或者大屏
    html.style.fontSize = "47px";
  } else {
    //兜底
    console.log("其他");
    html.style.fontSize = "40px";
  }
})();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
